import { render, staticRenderFns } from "./CsatMetrics.vue?vue&type=template&id=1243108d&scoped=true&"
import script from "./CsatMetrics.vue?vue&type=script&lang=js&"
export * from "./CsatMetrics.vue?vue&type=script&lang=js&"
import style0 from "./CsatMetrics.vue?vue&type=style&index=0&id=1243108d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243108d",
  null
  
)

export default component.exports